<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">This book would not have been possible without the support of Dennis Michael Edelin, chief archivist I of the Research Room Archival Operations at the National Archives in Washington, D.C., and Jessica Korgie, park guide for the Homestead National Historical Park in Beatrice, Nebraska. Mr. Edelin supported descendants by obtaining the homestead land entry papers during a difficult period, when access to these records was impossible due to the COVID-19 pandemic. Jessica Korgie worked tirelessly to publish the Black homesteader stories on the Homestead National Park Service’s (NPS) website. In addition, Amber Kirkendall, park ranger I and volunteer coordinator of Homestead National Historical Park, successfully mobilized a group of volunteers to transcribe the homestead land entry papers for their website.</p>
<p class="indent">I would like to acknowledge my husband, Glen Bennett, for his ongoing support of this project and my sister Janice A. Woods. In addition, I would like to say a special thanks to Denise Griggs for her expertise in editing and formatting this manuscript. Finally, Ric Murphy provided invaluable support and encouragement.</p>
<p class="indent">The descendants of Black homesteaders are recognized for their dedication in telling the stories of their ancestors. As family historians and genealogists, these descendants studied the homestead land entry papers, census records, gathered oral histories and used personal knowledge to write and share their stories. I applaud them and encourage others to follow in their footsteps.</p>
<p class="indent">The descendants and contributors to this book are acknowledged by each state.</p>
<p class="subhead">ALABAMA</p>
<p class="noindent">Dr. Mary K. Clark, Lyle Gibson, Orice Jenkins, Marcia Green Lamar and Charles E. Wilson.</p>
<p class="subhead">ARKANSAS</p>
<p class="noindent">Lyle Gibson, Susan Lasley, Jessica Trotter and Angela Walton-Raji.</p>
<p class="subhead">FLORIDA</p>
<p class="noindent">Falan Goff, Orice Jenkins, Deborah Mitchell and Margo Lee Williams.</p>
<p class="subhead">LOUISIANA</p>
<p class="noindent">Bernice A. Bennett, Alvin Blakes, Jackie M.B. Chapman, Claretha Day, Dr. Delores Mercedes Franklin, Lyle Gibson, Dr. Antoinette Harrell, Dr. Rex Holiday, Kimberli Hornes, Caleb Ricard, Clara Robertson, Felix Scott Jr., Marilyn Stubblefield and Crystal Williams-Jackson.</p>
<p class="subhead">MISSISSIPPI</p>
<p class="noindent">Alvin Blakes, Jonnie Ramsey Brown, Sandra Williams Bush, Nona Edwards-Thomas MD, Denise Griggs, Norma B. Hall, Dr. Antoinette Harrell, Eric Williams, Gordon Williams family and Luanne Wills-Merrell.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?6da3fc4e